import { useEffect, useState } from 'react'
import { subscribeVideoAIBackfill } from '../services/videoAI'

/**
 * The event's latest "Analyze existing videos" job, live, with `done`,
 * `failed` and `analyzed` counts — or null when it has never had one.
 * `enabled` false subscribes to nothing: only a sysadmin may read the job.
 */
export function useVideoAIBackfill(eventId, enabled = true) {
  // Keyed by event, so moving to another event shows nothing until its own
  // snapshot arrives rather than the previous event's job.
  const [state, setState] = useState({ eventId: null, job: null })

  useEffect(() => {
    if (!enabled || !eventId) return undefined
    return subscribeVideoAIBackfill(eventId, (job) => setState({ eventId, job }))
  }, [eventId, enabled])

  return enabled && state.eventId === eventId ? state.job : null
}
